import { useEffect, useState } from 'react';
import Html from './html';
import { useSelector } from 'react-redux';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { toast } from 'react-toastify';
const LogoSetting = (p) => {
  const [form, setForm] = useState({ title: "", mobileNo: "", email: "", address: "", website: "", dialCode: "" });
  const user = useSelector((state) => state.user);
  const [subbmitted, setsubbmitted] = useState(false)

  const GetData = () => {
    loader(true)
    ApiClient.get(`settings`).then((res) => {
      if (res?.success) {
        loader(false)
        setForm({
          ...form,
          id: res?.data?.[0]?.id || res?.[0]?._id,
          title: res?.data?.[0]?.title,
          mobileNo: res?.data?.[0]?.mobileNo,
          email: res?.data?.[0]?.email,
          address: res?.data?.[0]?.address,
          website: res?.data?.[0]?.website,
          dialCode: res?.data?.[0]?.dialCode
        })
      }
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setsubbmitted(true)
    if (!form?.mobileNo) {
      return
    }
    let payload = { ...form }
    loader(true)
    ApiClient.put(`setting`, payload).then((res) => {
      if (res.success) {
        loader(false)
        toast.success(res.message)
        GetData()
      }
    })
  }

  useEffect(() => {
    GetData()
  }, [])

  return (
    <>
      <Html
        handleSubmit={handleSubmit}
        form={form}
        setForm={setForm}
        subbmitted={subbmitted}
      />
    </>
  );
};
export default LogoSetting;
